module.exports = __webpack_public_path__ + "static/media/organiser-dashboard.4b7354c3.png";